import { COUNTRIES_INFO } from '../constants/countries';

export const removePhoneNumCountryCode = (phone: string, country: string = 'EGY') => {

  const numWithoutPhoneCountryCode = phone.replace(
    COUNTRIES_INFO[country].phone_country_code,
    ''
  );

  return numWithoutPhoneCountryCode;
};
